<modal [show]="show"
       (onClose)="no()"
       [publish]="publish"
       [showClose]="false" class="modal-dialog-container confirmation-dialog">
    <div class="modal-body">
        <h4 class="confirmation-dialog-heading">{{ 'general.confirm' | translate }}</h4>
        <div class="confirmation-modal-body">{{question | translate}}</div>
        <div class="text-center mt-3">
            <primary-text-button 
                                [noLeftPadding]="true"
                                (click)="yes()">
                    {{'confirm.yes' | translate }}
            </primary-text-button>
            <cancelary-text-button (click)="no()">
                {{'confirm.no' | translate }}
            </cancelary-text-button>
        </div>
    </div>
</modal>